import {useEffect, useRef, useState} from "react";
import {BiDownArrow} from "react-icons/bi";
import {IoIosArrowDown} from "react-icons/io";
import MenuDropdown from "../dropdown/MenuDropdown/MenuDropdown";

export default function Filter({className, title, onChange, data, defaultValue, options, ...props}) {
    const [value, setValue] = useState(defaultValue ? defaultValue : options.length > 0 ? options[0].value : "")
    const isfirstRender = useRef(true);
    useEffect(() => {
        if (isfirstRender.current) {
            isfirstRender.current = false;
            return;
        }
        if (onChange) onChange(value)
    }, [value])

    function getName() {
        for (let i = 0; i < options.length; i++) {
            if (options[i].value === value) {
                return options[i].name
            }
        }

        return ""
    }

    return (
        <MenuDropdown
            button={
                <div
                    className={`flex lg:min-w-[120px] flex-row gap-2 cursor-pointer justify-center items-center ${className}`}>
                    <p className={"text-sm text-gray-400 text-center w-full"}>
                        {title}
                    </p>
                    <div className={"flex flex-row gap-2  justify-center items-center"}>
                        <p className={"font-semibold whitespace-nowrap "}>
                            {getName()}
                        </p>
                        <IoIosArrowDown className={"text-tertiary-900"}/>
                    </div>
                </div>
            }

            classNames={"py-2 top-4 -left-[120px] w-max"}
        >

            <div
                className="flex w-56 flex-col  justify-start rounded-lg bg-gray-50 bg-cover bg-no-repeat shadow-2xl">

                {options.map((option, index) => {
                    return (
                        <div
                            key={index}
                            onClick={() => setValue(option.value)}
                            className={"justify-center border-b-[1px] py-1 hover:bg-gray-100 cursor-pointer items-center flex"}>
                            <p className={"font-semibold whitespace-nowrap "}>
                                {option.name}
                            </p>

                        </div>

                    )
                })}
            </div>

        </MenuDropdown>

    )
}